module.exports = __webpack_public_path__ + "img/logo-circle.c08ad3f3.svg";